module.exports = __webpack_public_path__ + "img/produit_vege.bb054646.png";